<template>
    <v-btn x-large class="w-100 px-16 px-lg-20 justify-space-between" rounded elevation="0" v-bind="{ loading }" @click="toggleSchedule" color="grey-light">
        <span class="grey-dark--text"> {{ disabled ? "마감" : "종일" }} </span>
        <v-simple-checkbox :class="{ 'd-none': disabled }" :value="isChecked" dense hide-details color="primary" style="pointer-events: none" v-bind="{ disabled }" />
    </v-btn>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        loading: { type: Boolean, default: false },

        schedules: { type: Array, default: () => [] },
        schedulesOnCloud: { type: Array, default: () => [] },
        subject: { type: Object, default: () => ({}) },
        date: { type: String },
        _user: { type: String },
        limitationMet: { type: Boolean, default: false },
    },
    computed: {
        schedule() {
            const { date, _user } = this;
            return { _subject: this.subject?._id, _user, date, isWholeDayRent: true };
        },
        isChecked() {
            let { _subject, date } = this.schedule;
            return this.schedules.some((item) => item._subject == _subject && item.date == date && item.isWholeDayRent);
        },
        disabled() {
            let hasSchedule = this.schedulesOnCloud.some(({ date }) => dayjs(date).isSame(dayjs(this.date), "date"));
            if (hasSchedule) return true;

            return !this.isChecked && this.limitationMet;
        },
    },
    methods: {
        toggleSchedule() {
            if (this.isChecked) this.$emit("del", this.schedule);
            else if (this.limitationMet) alert("한 주 동안 3시간을 초과해 대여할 수 없습니다");
            else if (this.disabled) alert("마감된 스케줄입니다");
            else this.$emit("add", this.schedule);
        },
    },
};
</script>

<style scoped></style>
